module.exports = __webpack_public_path__ + "img/info-con.40dd4d64.png";